import $ from "jquery";
import moment from "moment";
/* eslint-disable
    class-methods-use-this,
    consistent-return,
    func-names,
    global-require,
    max-len,
    no-multi-assign,
    no-new,
    no-restricted-syntax,
    no-return-assign,
    no-shadow,
    no-undef,
    no-underscore-dangle,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import ReactDOM from "react-dom";
import { View } from "backbone";
import Cookies from "js-cookie";
import AudioPlayerView from "views/audio_player_view";
import OuterView from "views/outer_view";
import TopbarStayInformedView from "views/topbar_stay_informed_view";
import TopbarToggleMenu from "views/topbar_toggle_menu";
import EditorialMenu from "views/editorial_menu";
import EditorialSidebarMenu from "views/editorial_sidebar_menu";
import ErrorTrack from "lib/error_track";
import Flash from "lib/flash";
import initSmallLayout from "layouts/small";
import { isSessionActive } from "lib/currentUser/session";
import currentRegion from "lib/currentRegion";
import morphdom from "morphdom";
import TopbarDynamicContent from "containers/TopbarDynamicContent";
import { withApolloProvider } from "lib/apolloClient";

let BasePage;

// Page base class
//
// Every page on TC should have a TC.page object which is an instance of a page class. This BasePage class is used when there is nothing more specific required.
//
// Basic page initialization should happen here.
export default BasePage = (function () {
  BasePage = class BasePage extends View {
    static initClass() {
      // All pages are attached to the body
      this.prototype.el = document.body;

      this.prototype._initSmallLayout = initSmallLayout;
    }

    initialize(options) {
      // Start bugsnag tracking for people with active sessions so we can debug
      // issues with loading dynamic content if they come up
      if (isSessionActive()) { ErrorTrack.start(); }

      this.audioPlayers = this.$("audio").each((i, el) => new AudioPlayerView({ audioEl: el }));

      this.outerEl = this.$("#outer");
      this.topbar = this.$("#topbar");
      this.header = this.$("#header");
      this.footers = this.$("#footers");
      this.outerView = new OuterView({
        el: this.outerEl,
        topbar: this.topbar,
        header: this.header,
        footers: this.footers,
      });

      this.editorialSidebarMenu = new EditorialSidebarMenu({ el: this.$el });
      this.editorialMenu = new EditorialMenu({ el: this.$el });

      this._initDynamicTopbarContent();
      this._initSVGHandling();
      this._initJSHandling();
      this._initLocalTimes();
      this._initRelativeTimes();
      this._initFlashMessages();
      this._initTopbarMenu();
      return this._initSmallLayout();
    }

    _initDynamicTopbarContent() {
      const topbarDynamicContentNode = document.getElementById("topbar-dynamic-content");

      if (TC.currentUser && TC.currentUser.hasAccessTo("new_account_menu")) {
        if (topbarDynamicContentNode) {
          ReactDOM.render(React.createElement(withApolloProvider(TopbarDynamicContent)), topbarDynamicContentNode);
        }
      } else if (isSessionActive()) {
        ErrorTrack.start();

        currentRegion()
            .then(regionCode => $.ajax({ url: `/${regionCode}/dynamic_content` }))
            .then((data) => {
              if (data.topbar) {
                morphdom(document.getElementById("topbar"), data.topbar);

                this._initTopbarMenu();
              }
            }).catch(() => ErrorTrack.notify("Dynamic content failed to load"));
      }
    }

    _initLocalTimes() {
      return $("time[data-format]").each((index, el) => {
        const format = $(el).data("format");
        const time = $(el).attr("datetime");
        if (format && time) {
          const momentTime = moment(time);
          $(el).html(TC.time.formatted(momentTime, format));
          return $(el).attr("title", momentTime.toDate());
        }
      });
    }

    _initRelativeTimes() {
      return $("time[data-relative]").each((index, el) => {
        const time = $(el).attr("datetime");
        if (time) {
          const momentTime = moment(time);
          $(el).html(momentTime.fromNow());
          return $(el).attr("title", momentTime.toDate());
        }
      });
    }

    // We mimic the test from Modernizr here because it was the only feature
    // of it we used, and hence, was able to remove it.
    _initSVGHandling() {
      if (document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1")) {
        return $("html").addClass("svg");
      }
      return $("html").addClass("no-svg");
    }

    // Assuming we've gotten this far, JS is up and running.
    _initJSHandling() {
      return $("html").addClass("js").removeClass("no-js");
    }

    _initFlashMessages() {
      // Add behaviour to existing flashes in markup
      Flash.bindServerFlash();
    }

    _initTopbarMenu() {
      // Each of the menus we expect to see rendered into the topbar
      const menuSelectors = [".topbar-edition-selector", ".topbar-account-nav"];

      // Now we need to inject some dynamically written CSS. This is absolutely
      // a giant hack which deals with the fact our legacy Javscript has no state
      // control whatsoever.
      //
      // This CSS must live outside the #topbar tree and must not mutate once
      // written so that is able to help persist UI state in the topbar menus
      // even if the #topbar tree gets replaced completely.
      //
      // Ideally, this would be controlled with explicit state in React components
      // and not random css classes being added and removed...
      if (!this.topbarMenuStyles) {
        this.topbarMenuStyles = document.createElement("style");
        this.topbarMenuStyles.type = "text/css";

        menuSelectors.forEach((selector) => {
          this.topbarMenuStyles.innerHTML += `
            body${selector}-open ${selector} .menu {
              display: block;
              z-index: 8;
            }

            body${selector}-open ${selector} .menu-button-contents {
              position: relative;
              border-bottom: 1px solid #fff;
              margin-bottom: -1px;
              z-index: 10;
            }
          `;
        });

        document.head.appendChild(this.topbarMenuStyles);
      }

      menuSelectors.forEach((selector) => {
        new TopbarToggleMenu({ el: this.$(selector), selector });
      });

      return new TopbarStayInformedView({ el: this.$(".topbar-stay-informed") });
    }
  };
  BasePage.initClass();
  return BasePage;
}());
